import { create, deletion } from '../methods';
import { Resource } from '../Resource';
const rootPath = 'smag';
export const fromRaw = {
    buildUrl: (raw) => raw,
    smagTokens: (tokens) => {
        return { refreshToken: tokens.refresh_token, token: tokens.token };
    },
    weenatToken: (token) => {
        return token;
    },
    infos: (infos) => {
        return {
            isAssociated: infos.is_associated,
            refreshToken: infos.smag_refresh_token,
            token: infos.smag_access_token,
            applicationId: infos.application_id
        };
    }
};
export const toRaw = (form) => ({
    refresh_token: form.refreshToken,
    token: form.token
});
const smag = Resource((requesterBuilder, { getCtx }) => {
    const host = getCtx().hosts.tiles;
    return {
        buildUrl: () => requesterBuilder({
            path: `${rootPath}/authentication/build_url`,
            requestCtx: {
                host,
                transform: fromRaw.buildUrl
            }
        }),
        login: create({
            toRaw: () => {
                return;
            },
            requesterBuilder,
            rootPath: `${rootPath}/authentication/login`,
            fromRaw: fromRaw.weenatToken,
            host
        }),
        refresh: create({
            toRaw: () => {
                return;
            },
            requesterBuilder,
            rootPath: `${rootPath}/authentication/refresh`,
            fromRaw: fromRaw.smagTokens,
            host
        }),
        logout: deletion({
            requesterBuilder,
            rootPath: `${rootPath}/authentication/logout`,
            host
        }),
        dissociate: deletion({
            requesterBuilder,
            rootPath: `${rootPath}/dissociate`,
            host
        }),
        infos: () => requesterBuilder({
            path: `${rootPath}/infos`,
            requestCtx: {
                host,
                transform: fromRaw.infos
            }
        }),
        associate: create({
            toRaw,
            requesterBuilder,
            rootPath: `${rootPath}/associate`,
            fromRaw: (x) => {
                return x;
            },
            parse: async (x) => x,
            host
        })
    };
});
export default smag;
